import { colors, VStack } from "goi_common";

/**
 * 백엔드 is_expired=true 응답을 받았을 때 부고 컨텐츠 대신 노출되는 전체 화면 Alert.
 * 만료 기준(발인 + 7일 또는 임시 키 만료)은 백엔드가 단일 계산.
 */
export const BugoVisitorPostFuneralAlert = () => {
  return (
    <VStack
      width="100%"
      alignItems="center"
      justifyContent="center"
      gap="12px"
      css={{
        minHeight: "100dvh",
        padding: "32px 24px",
        background: colors.warmGray50,
        textAlign: "center",
      }}
    >
      <p
        css={{
          fontSize: "17px",
          fontWeight: 700,
          color: colors.warmGray850,
          lineHeight: 1.6,
          margin: 0,
        }}
      >
        고인의 마지막 길에 함께해주셔서 감사합니다.
      </p>
      <p
        css={{
          fontSize: "15px",
          fontWeight: 500,
          color: colors.warmGray800,
          lineHeight: 1.6,
          margin: 0,
        }}
      >
        전해주신 마음은 가족분들께 큰 위로가 되었습니다.
      </p>
    </VStack>
  );
};
